import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PageBody, PageContent } from '@bit/knotchinc.web-react-components.page';
import FilterSideMenu from '@bit/knotchinc.web-react-components.filter-side-menu';
import DateFilter from '@bit/knotchinc.web-react-components.date-filter';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import FolderCard from 'components/Global/Card/FolderCard.jsx';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import ChecklistFilter from 'components/Global/Filters/ChecklistFilter/ChecklistFilter.jsx';
import TagFilter from 'components/Global/Filters/TagFilter/TagFilter.jsx';
import EntityFilter from 'components/Global/Filters/EntityFilter/EntityFilter.jsx';
// import SearchFilter from 'components/Global/Filters/SearchFilter/SearchFilter.jsx';
import SelectedFiltersBar from 'components/Global/Filters/SelectedFiltersBar/SelectedFiltersBar.jsx';
import LayoutToggle from 'components/Global/LayoutToggle/LayoutToggle.jsx';
import { ContentFeedContainer, FolderCardFeedContainer } from 'components/Pages/Home/styled.js';
import { SET_KEYWORDS_FILTER, SET_PUBLISHERS_FILTER, SET_CATEGORIES_FILTER } from 'components/Global/Filters/actions.js';
import Mixpanel from 'helpers/Mixpanel.js';
import BrandPaidStats from './BrandPaidStats.jsx';
import { LeftSideBarWrapper } from '../styled.js';
import {
  fetchBrandKeywords,
  fetchBrandCategories,
  fetchBrandPublishers,
  fetchPartnershipList,
  SET_BRAND_PAID_CONTENT_FILTER,
  SET_BRAND_TOP_KEYWORDS_FILTER,
  fetchBrandPaidContent,
} from '../actions';

const filteredTypeMap = { keyword_tags: true, categories: true, brand_ids: true, publisher_ids: true };
const isFilteredReduce = (filters) => {
  const filterKeys = Object.keys(filters);
  return filterKeys.reduce((filtered, filter) => {
    // always true if one filter is selected
    if (filtered) return true;
    if (filteredTypeMap[filter] && filters[filter].length) return true;
    return false;
  }, false);
};

class BrandPaidContentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutIsSpread: false,
      firstFetched: false,
    };

    this.props.setTopKeywordsFilter();
  }

  componentDidMount() {
    const { match: { params: { entityId } } } = this.props;
    Mixpanel.track('view Brand Paid Content', { id: entityId });
  }

  componentDidUpdate() {
    const {
      paidPartnershipList = {},
      metadata = {},
      history,
      match: {
        params: { entityId },
      },
    } = this.props;

    const { data, fetched } = paidPartnershipList;
    const { data: brandData = {} } = metadata;
    // handles a condition where we have paid content when we first land on the page (so we don't set firstFetched to true), then add a filter
    const isFiltered = paidPartnershipList.filters && isFilteredReduce(paidPartnershipList.filters);

    // redirect to owned tab if there's no paid content on the first time we land on the page.
    if (
      fetched &&
      !data.length && // no paid content
      brandData.has_hubs && // make sure we have data to display on the owned tab
      !this.state.firstFetched &&
      !isFiltered // only when content is not filtered
    ) {
      history.push(`/blueprint/brand/${entityId}/owned`);
    }

    if (!this.state.firstFetched) {
      this.setState({ firstFetched: true });
    }
  }

  handleToggle() {
    this.setState(prevState => {
      if (prevState.layoutIsSpread) {
        Mixpanel.track('changed to content feed');
        return { layoutIsSpread: false };
      }
      Mixpanel.track('changed to folder feed');
      return { layoutIsSpread: true };
    });
  }

  render() {
    const { layoutIsSpread } = this.state;
    const { metadata = {}, paidContentList = {}, paidPartnershipList = {}, categoriesList, keywordsList, publishersList,
      getPublishers, getCategories, getKeywords, getFeed, getPartnershipFeed, match } = this.props;

    const { params: { entityId } } = match;

    return (
      <PageBody>
        <BrandPaidStats entityId={entityId} background={metadata.data.hero_image_url} />
        <LeftSideBarWrapper>
          <LayoutToggle toggled={layoutIsSpread} toggleHandler={() => this.handleToggle()} />
          <FilterSideMenu clearAll={() => {}}>
            <DateFilter filterAction={SET_BRAND_PAID_CONTENT_FILTER} />
            {/* <SearchFilter filterAction={SET_BRAND_PAID_CONTENT_FILTER} /> */}
            <TagFilter
              title="keywords"
              type="keyword_tags"
              filters={paidContentList.filters}
              items={keywordsList}
              fetch={clear => getKeywords(clear)}
              selectedItems={paidContentList.filters.keyword_tags}
              filterAction={SET_BRAND_PAID_CONTENT_FILTER}
              listAction={SET_KEYWORDS_FILTER}
            />
            <ChecklistFilter
              type="categories"
              filters={paidContentList.filters}
              items={categoriesList}
              fetch={clear => getCategories(clear)}
              selectedItems={paidContentList.filters.categories}
              filterAction={SET_BRAND_PAID_CONTENT_FILTER}
              listAction={SET_CATEGORIES_FILTER}
            />
            <EntityFilter
              title="publishers"
              type="publisher_ids"
              filters={paidContentList.filters}
              items={publishersList}
              fetch={clear => getPublishers(clear)}
              selectedItems={paidContentList.filters.publisher_ids}
              filterAction={SET_BRAND_PAID_CONTENT_FILTER}
              listAction={SET_PUBLISHERS_FILTER}
            />
          </FilterSideMenu>
        </LeftSideBarWrapper>
        <PageContent>
          <SelectedFiltersBar hiddenFilters={['content_type']} filters={paidContentList.filters} filterAction={SET_BRAND_PAID_CONTENT_FILTER} />
          {layoutIsSpread ? (
            <ContentFeedContainer>
              <ListSync
                fetch={clear => getFeed(clear)}
                listStore={paidContentList}
                loadOnScroll
                actionType={SET_BRAND_PAID_CONTENT_FILTER}
                loadingPlaceholders={12}
              >
                <ContentCard />
              </ListSync>
            </ContentFeedContainer>
          ) : (
            <FolderCardFeedContainer>
              <ListSync
                fetch={clear => getPartnershipFeed(clear)}
                listStore={paidPartnershipList}
                loadOnScroll
                actionType={SET_BRAND_PAID_CONTENT_FILTER}
              >
                <FolderCard entity={metadata.data} contentType="paid" />
              </ListSync>
            </FolderCardFeedContainer>
          )}
        </PageContent>
      </PageBody>
    );
  }
}

const mapStateToProps = ({
  PublishersList: { publishersList },
  KeywordsList: { keywordsList },
  CategoriesList: { categoriesList },
  BrandProfile: { metadata, paidContentList, paidPartnershipList },
}) => ({ paidContentList, publishersList, categoriesList, keywordsList, paidPartnershipList, metadata });

const mapDispatchToProps = (dispatch, { match: { params: { entityId } } }) => ({
  getFeed: clear => dispatch(fetchBrandPaidContent(clear, entityId)),
  getPartnershipFeed: clear => dispatch(fetchPartnershipList(clear, entityId, 'brand')),
  getKeywords: clear => dispatch(fetchBrandKeywords(clear, entityId)),
  getCategories: clear => dispatch(fetchBrandCategories(clear, entityId)),
  getPublishers: clear => dispatch(fetchBrandPublishers(clear, entityId)),
  setTopKeywordsFilter: () => dispatch({ type: SET_BRAND_TOP_KEYWORDS_FILTER, filters: { contentType: 'paid' } }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandPaidContentView));
